/* global swal, _, angular*/
import './style.less';

export default function($log, $q, RegulatorClass, ApiClass, EventClass, HelperClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  vm.keyLength = item => Object.keys(item).length;

  vm.validURL = HelperClass.validateUrl;
  vm.isWebinarRegistration = EventClass.isWebinarRegistration;

  function activate() {
    $log.debug('Event summary Component Activated');
    $log.debug('Event summary Component Data', vm.ngModel);
    vm.loaded = false;
    vm.error = {};

    const promises = [RegulatorClass.loadRegulators()];

    if (vm.ngModel && !vm.ngModel.course_name && !vm.ngModel.event_id)
      promises.push(ApiClass.coursesIdGet({ id: vm.ngModel.course_id }));

    $q.all(promises)
      .then(function([regulatorReponse, courseResponse]) {
        $log.debug('Event Info Data', regulatorReponse, courseResponse);
        if (courseResponse) vm.ngModel = courseResponse.data.course;
        vm.regulatorDict = regulatorReponse.objCurrent;
        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = { status: error.status, refresh: activate };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/eventSummary/controller.js